<template>
  <div>
    <v-dialog persistent v-model="dialog" max-width="900" scrollable>
      <v-card class="filter-card">
        <v-card-title class="filter-header">
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="white">mdi-filter-variant</v-icon>
            <span class="headline font-weight-bold white--text">Patient Filter</span>
          </div>
          <v-btn 
            @click="cancel" 
            class="white--text close-header-btn" 
            icon
            large
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <!-- Township Filter Section -->
          <div class="filter-section mb-6">
            <div class="section-title mb-4">
              <v-icon class="mr-2" color="#aa00ff">mdi-map-marker</v-icon>
              <span class="subtitle-1 font-weight-bold">Filter by Township</span>
            </div>
            <v-row align="center">
              <v-col cols="12" md="8">
                <v-select
                  v-model="township_id"
                  placeholder="Select Township..."
                  outlined
                  item-text="name"
                  item-value="id"
                  :items="townships"
                  prepend-inner-icon="mdi-city"
                  clearable
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4" class="text-md-right">
                <v-btn
                  @click="searchByTownsip"
                  class="search-btn-purple"
                  large
                  block
                  :disabled="!township_id"
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-6"></v-divider>

          <!-- Nominated Support Filter Section -->
          <div class="filter-section">
            <div class="section-title mb-4">
              <v-icon class="mr-2" color="#aa00ff">mdi-calendar-check</v-icon>
              <span class="subtitle-1 font-weight-bold">Filter by Nominated Support</span>
            </div>
            <v-row>
              <v-col cols="12" md="3">
                <v-select
                  v-model="nominated_support_type"
                  placeholder="Enroll Type"
                  outlined
                  item-text="name"
                  item-value="id"
                  :items="supportTypes"
                  prepend-inner-icon="mdi-account-check"
                  clearable
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  :items="months"
                  v-model="nominated_month"
                  item-text="text"
                  item-value="value"
                  placeholder="Select Month"
                  outlined
                  prepend-inner-icon="mdi-calendar-month"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  :items="years"
                  v-model="nominated_year"
                  item-text="text"
                  item-value="value"
                  placeholder="Select Year"
                  outlined
                  prepend-inner-icon="mdi-calendar"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  @click="searchByNomated"
                  class="search-btn-purple"
                  large
                  block
                  :disabled="!nominated_month || !nominated_year"
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            @click="clearAllFilters"
            text
            color="grey darken-1"
            class="mr-3"
          >
            <v-icon left small>mdi-filter-off</v-icon>
            Clear All
          </v-btn>
          <v-btn
            @click="cancel"
            outlined
            color="grey darken-1"
            class="mr-2"
          >
            <v-icon left>mdi-close</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    dialog: {
      type: Boolean,
    },
  },
  data: () => ({
    search: "",
    supportStartDateMenu: false,
    supportStartDate: "",
    supportEndDateMenu: false,
    supportEndDate: "",
    township_id: null,
    supportTypes: [
      { id: 1, name: "Pre-Enroll" },
      { id: 2, name: "Enroll" },
    ],
    support_type: "",
    nominated_support_type:"",
    mdrtb_reg_no: "",
    mdrtb_reg_year: "",
    nominated_month: "",
    nominated_year: "",
    nominated_type: "",
    onGoingEndDate: "",
    onGoingEndDateMenu: "",
  }),
  computed: {
    ...mapState("Township", ["townships"]),
    ...mapState("InitialData", ["months"]),
    ...mapState("InitialData", ["years"]),
  },
  created() {
    this.$store.dispatch("Township/getTownships");
    if (!this.$route.query.page) {
      this.page = 1;
    } else {
      this.page = parseInt(this.$route.query.page);
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    searchByTownsip() {
      if (this.township_id) {
        this.$router.push(
          `/patient?township_id=${this.township_id}&page=${this.$route.query.page || 1}`
        );
        this.$emit("cancel");
      }
    },
    searchByText() {
      if (this.search) {
        this.$router.push(`/patient?search=${this.search}`);
        this.$emit("cancel");
      }
    },
    searchBySupportType() {
      if (this.support_type && this.supportStartDate && this.supportEndDate) {
        this.$router.push(
          `/patient?support_type=${this.support_type.id}&support_startdate=${this.supportStartDate}&support_enddate=${this.supportEndDate}`
        );
        this.$emit("cancel");
      }
    },
    searchByCode() {
      if (this.mdrtb_reg_no && this.mdrtb_reg_year) {
        this.$router.push(
          `/patient?mdrtb_reg_no=${this.mdrtb_reg_no}&mdrtb_reg_year=${this.mdrtb_reg_year}`
        );
        this.$emit("cancel");
      }
    },
    searchByNomated() {
      if (this.nominated_month && this.nominated_year) {
        const params = {
          nominated_month: this.nominated_month,
          nominated_year: this.nominated_year,
          page: this.$route.query.page || 1
        };
        if (this.nominated_support_type && this.nominated_support_type.id) {
          params.nominated_support_type = this.nominated_support_type.id;
        }
        const queryString = Object.keys(params)
          .map(key => `${key}=${params[key]}`)
          .join('&');
        this.$router.push(`/patient?${queryString}`);
        this.$emit("cancel");
      }
    },
    searchForOnging() {
      if (this.onGoingEndDate) {
        this.$router.push(`/patient?onGoingEnddate=${this.onGoingEndDate}`);
        this.$emit("cancel");
      }
    },
    clearAllFilters() {
      this.township_id = null;
      this.nominated_support_type = null;
      this.nominated_month = null;
      this.nominated_year = null;
      this.search = null;
      this.support_type = null;
      this.supportStartDate = null;
      this.supportEndDate = null;
      this.mdrtb_reg_no = null;
      this.mdrtb_reg_year = null;
      this.onGoingEndDate = null;
    },
  },
};
</script>

<style scoped>
.filter-card {
  border-radius: 12px;
  overflow: hidden;
}

.filter-header {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%);
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.2);
}

.close-header-btn {
  transition: all 0.3s ease;
}

.close-header-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  transform: rotate(90deg);
}

/* .filter-section {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #aa00ff;
} */

.section-title {
  display: flex;
  align-items: center;
  color: #424242;
  margin-bottom: 16px;
}

.section-title .v-icon {
  font-size: 24px;
}

.v-select,
.v-combobox,
.v-text-field {
  border-radius: 6px;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-btn:not(.v-btn--disabled) {
  transition: all 0.3s ease;
}

.v-btn:not(.v-btn--disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(170, 0, 255, 0.3);
}

.search-btn-purple {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.3) !important;
}

.search-btn-purple:hover:not(.v-btn--disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(170, 0, 255, 0.4) !important;
}

.v-card-actions {
  background-color: #fafafa;
}

@media (max-width: 960px) {
  .filter-section {
    margin-bottom: 24px;
  }
  
  .v-btn {
    margin-top: 8px;
  }
}
</style>
